import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";

var _dec, _class;

import _regeneratorRuntime from "@babel/runtime/regenerator";
import { injectable } from 'inversify';
import 'reflect-metadata';
import TileLayer from "../tile/tileLayer/BaseLayer";
/**
 * Layer Model 初始化，更新，销毁
 */

var LayerModelPlugin = (_dec = injectable(), _dec(_class = /*#__PURE__*/function () {
  function LayerModelPlugin() {
    _classCallCheck(this, LayerModelPlugin);
  }

  _createClass(LayerModelPlugin, [{
    key: "initLayerModel",
    value: function () {
      var _initLayerModel = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(layer) {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                // 更新Model 配置项
                layer.prepareBuildModel(); // 初始化 Model

                _context.next = 3;
                return layer.buildModels();

              case 3:
                layer.styleNeedUpdate = false;

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      function initLayerModel(_x) {
        return _initLayerModel.apply(this, arguments);
      }

      return initLayerModel;
    }()
  }, {
    key: "prepareLayerModel",
    value: function () {
      var _prepareLayerModel = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(layer) {
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                // 更新Model 配置项
                layer.prepareBuildModel(); // clear layerModel resource
                // 初始化 Model

                _context2.next = 3;
                return layer.buildModels();

              case 3:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      function prepareLayerModel(_x2) {
        return _prepareLayerModel.apply(this, arguments);
      }

      return prepareLayerModel;
    }()
  }, {
    key: "apply",
    value: function apply(layer) {
      var _this = this;

      layer.hooks.init.tapPromise('LayerModelPlugin', /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                if (!layer.getSource().isTile) {
                  _context3.next = 4;
                  break;
                }

                layer.prepareBuildModel();
                layer.tileLayer = new TileLayer(layer);
                return _context3.abrupt("return");

              case 4:
                _context3.next = 6;
                return _this.initLayerModel(layer);

              case 6:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      })));
      layer.hooks.beforeRenderData.tapPromise('LayerModelPlugin', /*#__PURE__*/function () {
        var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(flag) {
          return _regeneratorRuntime.wrap(function _callee4$(_context4) {
            while (1) {
              switch (_context4.prev = _context4.next) {
                case 0:
                  if (flag) {
                    _context4.next = 2;
                    break;
                  }

                  return _context4.abrupt("return", false);

                case 2:
                  if (!layer.getSource().isTile) {
                    _context4.next = 5;
                    break;
                  }

                  layer.tileLayer = new TileLayer(layer);
                  return _context4.abrupt("return", false);

                case 5:
                  _context4.next = 7;
                  return _this.prepareLayerModel(layer);

                case 7:
                  return _context4.abrupt("return", true);

                case 8:
                case "end":
                  return _context4.stop();
              }
            }
          }, _callee4);
        }));

        return function (_x3) {
          return _ref2.apply(this, arguments);
        };
      }());
    }
  }]);

  return LayerModelPlugin;
}()) || _class);
export { LayerModelPlugin as default };